export default "__VITE_ASSET__DOtNCEgU__"